var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"facial-device-modal","title":_vm.$t('DEVICE.FACIAL.PAGE.HEADER'),"title-class":"h4 font-weight-bold","lazy":"","size":"lg","hide-footer":""}},[_c('div',{staticClass:"d-flex flex-column px-3 py-2"},[_c('FacialDeviceEditForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }